import React from "react";
import {Redirect, useLocation} from "react-router-dom";
import {rootURL} from "shared/Utils/WhereAmI";
import useAuth from "shared/Auth/hooks/useAuth";
import Auth from "shared/Auth/auth";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";

type AgeVerificationWrapper = {
    children: React.ReactNode;
};

export function AgeVerificationWrapper({children}: AgeVerificationWrapper) {
    const {slug, features} = useUniversity();
    const location = useLocation();
    const {authState} = useAuth();
    const ageVerificationR1Enabled = features.get("ageVerificationR1");
    const rootUrl = rootURL(location.pathname);
    const ageVerificationInfo = authState?.me?.applicant?.ageVerificationInfo ?? null;
    const isApplicantUniversitySetup = Auth.isApplicantUniversitySetup(authState.me, slug);

    if (!isApplicantUniversitySetup && ageVerificationR1Enabled) {
        if (!ageVerificationInfo) {
            return (
                <Redirect
                    to={{
                        pathname: `${rootUrl}/auth/verify/age`,
                        state: {nextPathname: location?.state?.nextPathname},
                    }}
                />
            );
        } else if (ageVerificationInfo && ageVerificationInfo.isMinor) {
            return <Redirect to={`${rootUrl}/auth/minor`} />;
        }
    }

    return <>{children}</>;
}
